// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuoteFilterComponent } from "./quote-filter.component";
import { CardModule } from "libraries/ui_card/card.module";
import { SliderFieldModule } from './components/slider-field/slider-field.module';
import { FilterServiceModule } from '../../services/filter/filter-service.module';
import { MultiCheckBoxModule } from 'libraries/module/formbuilder/fields/multi-checkbox-field/multi-checkbox.module';
import { LabelModule } from 'libraries/service/label/label.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { CarbonFootprintModule } from "libraries/component/carbon-footprint/carbon-footprint.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CarbonFootprintModule,
        CardModule,
        CommonModule,
        DatePipeModule,
        FilterServiceModule,
        LabelModule,
        MultiCheckBoxModule,
        SliderFieldModule,
        ConfigurationResourceModule,
        LocalizedModule,
        FontAwesomeModule,
    ],
    declarations: [
        QuoteFilterComponent
    ],
    exports: [
        QuoteFilterComponent
    ],
})
export class QuoteFilterModule { }
